<template>
  <div class="buyzone__prices">
    <div class="price" :class="{ 'price--skip': hasYourPrice }">
      <span class="price__prefix">{{ getPricePrefix("default") }}</span>
      <span class="price__value">{{
        (isVariant && variant.price) || price
      }}</span>
      <span class="price__postfix">{{ postfix }}</span>
    </div>
    <div class="price price--green" v-if="hasYourPrice">
      <span class="price__prefix">{{ getPricePrefix("your") }}</span>
      <span class="price__value">{{ variant && variant.yourPrice || yourPrice }}</span>
      <span class="price__postfix">{{ postfix }}</span>
    </div>
  </div>
</template>

<script>
export default {
  name: "Prices",
  props: {
    price: {
      type: String,
      required: true
    },
    yourPrice: {
      type: String,
      required: false
    },
    variant: {
      type: Object,
      required: false
    },
    multi: {
      type: Boolean,
      default: false
    },
    postfix: {
      type: String,
      default: "Inkl. moms"
    }
  },
  data() {
    return {
      isVariant: false,
      hasYourPrice: false
    };
  },
  mounted() {
    this.update();
  },
  watch: {
    variant() {
      this.update();
    }
  },
  methods: {
    update() {
      this.isVariant = this.variant !== null && this.variant.price !== null;
      this.hasYourPrice = this.isVariant && this.variant.yourPrice !== null || this.yourPrice !== null;
    },
    getPricePrefix(type) {
      let part1 = "";
      if (type === "default" && this.hasYourPrice) {
        part1 = "Normalpris ";
      } else if (type === "your") {
        part1 = "Din pris ";
      }
      let part2 = !this.isVariant && this.multi ? "fra" : "";
      return part1 + part2;
    }
  }
};
</script>
